import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';
import { Button } from '@garnish/core';

import { BUTTON_HEIGHT } from '../../upsell.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellActionButton = (props: UpsellActionButtonProps) => {
  const { onPress, disabled, variant, palette = 'kaleLightest' } = props;

  const { formatMessage } = useIntl();

  const message = variant === 'continue' ? messages.continue : messages.close;

  return (
    <Button
      onPress={onPress}
      disabled={disabled}
      style={styles.button}
      size="large"
      palette={palette}
      accessibilityLabel={formatMessage(message)}
    >
      <FormattedMessage {...message} />
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  continue: {
    defaultMessage: 'Continue to bag',
    description: 'Upsell modal | Continue button | Text',
  },
  close: {
    defaultMessage: 'Back to menu',
    description: 'Upsell modal | Close button | Text',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    height: BUTTON_HEIGHT,
    paddingHorizontal: theme.spacing['8'],
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type UpsellActionButtonProps = {
  onPress: () => void;
  disabled?: boolean;
  variant: 'continue' | 'close';
  palette?: 'primary' | 'kaleLightest';
};
